export default "__VITE_ASSET__72e82c3f__"